<template>
  <el-scrollbar :height="menuHeight" view-class="menu-scrollbar-view">
    <el-menu class="menu" router :default-active="activeName" background-color="#304156" text-color="#fff" active-text-color="#ffd04b">
      <el-sub-menu :index="menu.url" v-for="menu in menus" :key="menu.id">
        <template #title>
          <i v-bind:class="menu.icon"></i>
          <span>{{menu.name}}</span>
        </template>
        <el-menu-item :index="childMenu.url" v-for="childMenu in menu.childMenus" :key="childMenu.id" @click="onClick(childMenu)">{{childMenu.name}}</el-menu-item>
      </el-sub-menu>
    </el-menu>
  </el-scrollbar>
</template>

<script lang="ts">
import bus from "@/script/core/util/Bus";
import { MenuService } from "@/script/apps/system/service/MenuService";
import { MenuData } from "@/script/core/base/MenuData";
import { Menu as MenuEntity } from "@/script/apps/system/entity/SystemEntity";
import { ElMessage } from "element-plus";
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import { TabItem } from "@/store/TabItem";

@Options({})
export default class Menu extends Vue {
  private menuHeight?: number;
  private menus: Menu[] = [];
  private activeName = "/index";

  beforeCreate() {
    this.menuHeight = document.body.clientHeight - 90;
  }

  created() {    
    const self = this;
    const menuService = new MenuService();
    menuService.loadMenuList(
      store.getters.loginUser.id,
      function(data: any) {
        self.menus = data;
      },
      function(error: Error) {
        ElMessage.error("读取菜单失败，失败原因：" + error.message);
      }
    );
    bus.on("tab-active", (data: any) => {
      this.activeName = data;
    });
  }

  onClick(menu: MenuEntity) {
    const menuData: MenuData = {
      name: String(menu.url),
      path: String(menu.url),
      title: String(menu.name),
      isClose: true
    };
    bus.emit("menu-select", menuData);
  }
}
</script>

<style lang="scss">
.menu-scrollbar-view {
  height: 100%;
}
</style>
